const FromArrEditor = [{
		key: 'Year',
		modelvalue: undefined,
		title: "年度：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	}, {
		key: 'InvClass',
		modelvalue: undefined,
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	}, {
		key: 'LEVEL3',
		modelvalue: undefined,
		title: "Level3：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 210,
		height: 32,
		disabled: true,
		marginLeft: 60,
		marginTop: 5,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
	},
	{
		key: 'AreaMan',
		title: "小区经理：",
		// inputtype: "input",
		inputtype: "selectSingle",
		modelvalue: '',
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: true,
		marginLeft: 32,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'AuthorizedDealer',
		event: 'AuthorizedDealerChange'
	},
	{
		key: 'JanMoneyQuota',
		modelValue: undefined,
		title: "一月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 36,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'FebMoneyQuota',
		modelValue: undefined,
		title: "二月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'MarMoneyQuota',
		modelValue: undefined,
		title: "三月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'AprMoneyQuota',
		modelValue: undefined,
		title: "四月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'MayMoneyQuota',
		modelValue: undefined,
		title: "五月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'JunMoneyQuota',
		modelValue: undefined,
		title: "六月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'JulMoneyQuota',
		modelValue: undefined,
		title: "七月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'AugMoneyQuota',
		modelValue: undefined,
		title: "八月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'SepMoneyQuota',
		modelValue: undefined,
		title: "九月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'OctMoneyQuota',
		modelValue: undefined,
		title: "十月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'NovMoneyQuota',
		modelValue: undefined,
		title: "十一月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	},
	{
		key: 'DecMoneyQuota',
		modelValue: undefined,
		title: "十二月金额指标：",
		inputtype: "NumberInput",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 210,
		height: 32,
		disabled: false,
		marginLeft: 28,
		marginTop: 20,
		displayVal: "inline-block",
		fontWeightVal: 500,
		max: undefined,
		min: 0
	}
];
export default FromArrEditor;
